import { render, staticRenderFns } from "./PainelProjetosGeral.vue?vue&type=template&id=51f618e5"
import script from "./PainelProjetosGeral.vue?vue&type=script&lang=js"
export * from "./PainelProjetosGeral.vue?vue&type=script&lang=js"
import style0 from "./PainelProjetosGeral.vue?vue&type=style&index=0&id=51f618e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports